import { Card, CardBody, CardHeader, Collapse } from "reactstrap";
import { Href } from "../../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../../ReduxToolkit/Hooks";
import { setAccount } from "../../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";

const DeleteAccount = () => {
  const { account } = useAppSelector((state) => state.mainSidebar);
  const dispatch = useAppDispatch();
  return (
    <Card>
      <CardHeader onClick={() => dispatch(setAccount(account !== "6" ? "6" : ""))}>
        <a href={Href}>
          Delete My account
          <i className={`fa fa-angle-${account === "6" ? "up" : "down"}`} />
        </a>
      </CardHeader>
      <Collapse className={`${account === "6" ? "show" : ""}`}>
        <CardBody>
          <a className="p-0 req-info font-danger" href={Href}>Delete Account</a>
          <p><b>Note :</b>Deleting your account will delete your account info, profile photo, all groups & chat history.</p>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default DeleteAccount;
